import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { AppraisifyCommentaryModule } from '../../modules/appraisifyCommentary/AppraisifyCommentaryModule.tsx';
import { selectIsCommentaryLoaded } from '../../redux/features/selectors/commentarySelectors/selectIsCommentaryLoaded.ts';
import { useAppSelector } from '../../redux/hooks.ts';

export const AppraisifyCommentaryRouteElement = () => {
  const isLoaded = useAppSelector((state) => selectIsCommentaryLoaded(state));

  return (
    <ModuleContainer moduleID="appraisify-commentary" compact>
      {isLoaded && <AppraisifyCommentaryModule />}
    </ModuleContainer>
  );
};
